<div class="related-documents">
  @for (section of relDocumentsView?.sections; track section?.layer?.uId) {
    <div>
      @if (section.dataset) {
        <div
          class="header"
          fxLayout="row"
          fxLayoutAlign="start center"
          fxLayoutGap="8px">
          <div
            fxLayout="row"
            fxLayoutAlign="start center"
            fxLayoutGap="4px">
            <div
              class="expand-collapse"
              (click)="onExpandCollapse(section)">
              @if (isSectionExpanded(section)) {
                <i
                  class="icon icon-arrow_reveal_down"
                style="font-size: 24px; position: relative; top: 2px"></i>
              }
              @if (!isSectionExpanded(section)) {
                <i
                  class="icon icon-arrow_reveal_right"
                style="font-size: 24px; position: relative; top: 2px"></i>
              }
            </div>
            @if (!!section.icon.path) {
              <div
                fxLayout="row"
                fxLayoutAlign="space-around center"
                class="mr-2">
                @if (section.icon.path && !section.icon.iconBgColor && !section.icon.iconFgColor) {
                  <img
                    class="typeIcon"
                    [src]="section.icon" />
                }
                @if (section.icon.iconBgColor && section.icon.iconFgColor) {
                  <div
                    class="typeIcon"
                    [ngStyle]="{ 'background-color': section.icon.iconBgColor }">
                    <i
                      class="icon"
                      [ngClass]="section.icon.path"
                    [ngStyle]="{ color: section.icon.iconFgColor, 'font-size.rem': 1.5 }"></i>
                  </div>
                }
              </div>
            }
            @if (!!!section.icon.path) {
              <div
                class="typeIcon mr-2"
                [style]="'background-color:' + (section.color || '#FFFFFF') + ';color:#FFFFFF;'"
                fxLayout="row"
                fxLayoutAlign="space-around center">
                @if (!section.isCustomIcon) {
                  <div
                    class="material-icons"
                    style="font-size: 16px">
                    {{ section.iconPath }}
                  </div>
                }
                @if (section.isCustomIcon) {
                  <img
                    [src]="section.iconPath | safeUrl"
                    class="customIcon" />
                }
              </div>
            }
            <div>
              @if (section.dataset) {
                <div
                  class="typeName ml-2"
                  >
                  {{ section.dataset.name }} ({{ section?.count }})
                </div>
              }
            </div>
          </div>
        </div>
      }
      @if (isSectionExpanded(section)) {
        <div
          class="body"
          >
          @for (item of section?.cards; track item?.document?.uid) {
            <div>
              @if (isPersonCard(item)) {
                <topo-related-person-card
                  [isActive]="true"
                  (click)="onClickCard($event)"
                  (zoomToDocument)="onZoomToDocument($event)"
                [card]="item"></topo-related-person-card>
              }
              @if (isFacilityCard(item)) {
                <topo-related-facility-card
                  [isActive]="true"
                  (click)="onClickCard($event)"
                  (zoomToDocument)="onZoomToDocument($event)"
                [cards]="section?.cards"></topo-related-facility-card>
              }
              @if (isIncidentCard(item)) {
                <topo-related-incident-card
                  [isActive]="true"
                  (click)="onClickCard($event)"
                  (zoomToDocument)="onZoomToDocument($event)"
                [card]="item"></topo-related-incident-card>
              }
              @if (isNormalCard(item)) {
                <topo-related-document-card
                  [isActive]="true"
                  (click)="onClickCard($event)"
                  (zoomToDocument)="onZoomToDocument($event)"
                [card]="item"></topo-related-document-card>
              }
            </div>
          }
        </div>
      }
    </div>
  }
</div>
